<template>
  <div>
    <div class="container contprofile py-5">
      <div class="row">
        <menu-profile></menu-profile>
        <div class="col-md-6 col-lg-8">
          
          <grouping></grouping>
          <!--          <apexchart-->
          <!--            class="w-100"-->
          <!--            type="bar"-->
          <!--            :options="chartOptions"-->
          <!--            :series="series"-->
          <!--          ></apexchart>-->
        </div>
      </div>
    </div>
    <div class="action my-auto">
                 <new-project></new-project>
 </div>
  </div>
</template>

<script>
import grouping from "./Components/Grouping";
import menu from "../Shared/MenuProfile";
import newproject from "../../Shared/Componensts/newproject.vue";
export default {
  components: {
    grouping: grouping,
    "menu-profile": menu,
    "new-project": newproject,
  },
};
</script>

<style lang="scss" scoped>
.contprofile {
  margin-top: 130px;
}

.action{
    position: fixed;
    bottom: 3rem;
    left: 5%;
    z-index: 12;

  button{
    border-radius: 50%;
    width: 5rem;
    height: 5rem;
    border: 3px solid #3bcf93;
    padding: 1px;
    
  }
}
</style>